// initial state
const state = () => ({
  products: [],
  productTitle: "",
  activeProduct: undefined,
  defaultProduct: undefined,
  activeVariant: undefined,
  defaultVariant: undefined,
  variants: []

});

// getters
const getters = {
  getProducts: (state) => {
    return state.products.map((product) => {
      return product;
    });
  },
  getProductTitle: (state) => {
    return state.productTitle;
  },
  getDefaultProduct: (state) => {
    return state.defaultProduct;
  },
  getActiveProduct: (state) => {
    return state.activeProduct;
  },
  getDefaultVariant: (state) => {
    return state.defaultVariant;
  },
  getActiveVariant: (state) => {
    return state.activeVariant;
  },
  getVariants: (state) => {
    return state.variants.map((variant) => {
      return variant;
    });
  },
  queryProducts: (state) => (queryObject) => {
    const queryCopy = Object.assign({}, queryObject);
    let findMultiple = false;
    if (queryCopy.findMultiple) {
      findMultiple = queryCopy.findMultiple;
      delete queryCopy.findMultiple;
    }
    const findFunction = (productObject) => {
      let isMatch = true;
      Object.keys(queryCopy).forEach((key) => {
        if (!productObject[key] || productObject[key] !== queryCopy[key]) {
          isMatch = false;
        }
      });
      return isMatch;
    };
    if (findMultiple) {
      return state.products.filter(findFunction);
    } else {
      return state.products.find(findFunction);
    }
  },
  queryVariants: (state) => (queryObject) => {
    const queryCopy = Object.assign({}, queryObject);
    const findFunction = (variantObject) => {
      let isMatch = true;
      Object.keys(queryCopy).forEach((key) => {
        if (!variantObject[key] || variantObject[key] !== queryCopy[key]) {
          isMatch = false;
        }
      });
      return isMatch;
    };
    return state.variants.find(findFunction);
  },
};

// actions
const actions = {
  setProducts({ commit }, products) {
    commit("setProducts", { products });
  },
  activateProduct({ commit }, { activeProduct }) {
    commit("setActiveProduct", activeProduct);
  },
  setDefaultProduct({ commit }, product) {
    commit("setDefaultProduct", { product });
  },
  setProductTitle({ commit }, title) {
    commit("setProductTitle", { title });
  },
  activateVariant({ commit }, { activeVariant }) {
    commit("setActiveVariant", activeVariant);
  },
  setDefaultVariant({ commit }, variant) {
    commit("setDefaultVariant", { variant });
  },
  setVariants({ commit }, variants) {
    commit("setVariants", { variants });
  },
};

// mutations
const mutations = {
  setProducts(state, { products }) {
    const optionKeys = ["fabric", "cushion", "leg"];
    state.products = products.map((product) => {
      const productCopy = Object.assign({}, product);
      const additionalComponents = [];
      optionKeys.forEach((key) => {
        if (product[key]) {
          additionalComponents.push(
            `${key}=${encodeURIComponent(product[key]).replaceAll("%20", "+")}`
          );
        }
      });
      if (additionalComponents.length > 0) {
        const baseQuery = productCopy["query"];
        if (baseQuery !== "?") {
          productCopy["query"] = [
            baseQuery,
            additionalComponents.join("&"),
          ].join("&");
        } else {
          productCopy["query"] = baseQuery + additionalComponents.join("&");
        }
      }
      return productCopy;
    });
  },
  setActiveProduct(state, newProduct) {
    state.activeProduct = newProduct;
  },
  setDefaultProduct(state, { product }) {
    state.defaultProduct = product;
  },
  setProductTitle(state, { title }) {
    state.productTitle = title;
  },
  setActiveVariant(state, activeVariant) {
    state.activeVariant = activeVariant;
  },
  setDefaultVariant(state, { variant }) {
    state.defaultVariant = variant;
  },
  setVariants(state, { variants }) {
    state.variants = variants;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
